export default __webpack_public_path__ + "static/media/share.65295838.svg";